import styled from 'styled-components';

export const IntegrationHeaderStyled = styled.div`
  margin-bottom: ${({ theme }) => `${theme.spacing(8)}px`};
`;

export const IntegrationBackLink = styled.div`
  margin-left: ${({ theme }) => `-${theme.spacing(2)}px`};
`;
